import { Link } from 'react-router-dom'
import { useCampaignStore } from '../app/store/campaignStore'
import Card from '../templates/ui/Card'
import Button from '../templates/ui/Button'

export default function JourneyHub() {
  const { state } = useCampaignStore()

  const steps = [
    { key: 'receipt', title: 'เปิดบิล เช็กดวง', path: '/game/mutelu/scan' },
    { key: 'result', title: 'ผลลัพธ์มูเตลู', path: '/game/mutelu/receipt' },
    { key: 'claim-reward', title: 'รับรางวัล', path: '/game/mutelu/claim-reward' }
  ]

  return (
    <section className="mobile-page">
      <h1 className="text-2xl font-extrabold text-[#2f6d17]">Journey</h1>
      <Card className="mobile-panel">
        <div className="grid gap-3">
          {steps.map((step) => {
            return (
              <Card key={step.key} className="border-[#dbe8c7]">
                <p className="text-sm font-bold text-[#2f6d17]">{step.title}</p>
                <p className="mt-2 text-xs text-slate-500">
                  {step.key === 'result' && !state.receiptNo ? 'แนะนำให้กรอกเลขใบเสร็จก่อน' : 'พร้อมใช้งาน'}
                </p>
                <Link to={step.path} className="mt-3 block">
                  <Button className="w-full">
                    เข้าสเต็ป
                  </Button>
                </Link>
              </Card>
            )
          })}
        </div>
      </Card>
    </section>
  )
}
